export const environment = {
  production: false,
  googleAnalyticsId: '' as string,
  apiBaseUrl: 'https://aaehackathon.nhaad.in/controlplane/',
  catalogueUiUrl: 'https://nha.iudx.io',
  email: 'info@nha.org.in',
  keycloak: {
    url: 'https://aaehackathon.nhaad.in/auth/',
    realm: 'nha',
    clientId: 'angular-client',
  },

  // Api URLS
  basePathUrl: 'https://aaehackathon.nhaad.in/controlplane/',
  baseFilePathUrl: 'https://aaehackathon.nhaad.in/files-connect-api/',
  baseRsPathUrl: 'https://aaehackathon.nhaad.in/dataplane/',
  baseSandboxPathUrlCpu: 'https://aaehackathon.nhaad.in/sandbox-api/v1/',
  baseSandboxPathUrlGpu: 'https://aaehackathon.nhaad.in/sandbox-api/v1/',
  baseCommunityPathUrl: 'https://nha.maharashtra.gov.in/community/',
  dataReadinessS3Url:
    'https://data-readiness-prod.s3.cyfuture.cloud/data-readiness-prod/',
  baseChallengePathUrl: 'https://nha.maharashtra.gov.in/community/challenge',
  auditingApiPath: 'iudx/v2/auditing/',
  authApiPath: 'iudx/v2/auth/',
  catApiPath: 'iudx/v2/cat/',
  aclapdPath: 'iudx/acl/apd/v2/',
  leadershipApiPath: 'iudx/v2/leaderboard/',

  userManualUrl:
    'https://data-readiness-prod.s3.cyfuture.cloud/user-manual/User%20Manual%20-%20NHA%20v1.0.pdf?domain=data-readiness-prod.s3.cyfuture.cloud',

  userApiPath: 'iudx/v2/auth/user/',
  userInteractionApiPath: 'iudx/v2/user',
  activitiesApiPath: 'iudx/v2/auditing/consumer/activity',
  rolesApiPath: 'iudx/v2/auth/roles',
  roleUpgradeApiPath: 'iudx/v2/auth/organization/user/provider_role/requests',

  ogcApiPath: 'https://v2.dev.ogc-s3.iudx.io/',
  api_ogc_server_domain: 'https://v2.dev.ogc-s3.iudx.io/',
  ngsiLdApiPath: 'https://aaehackathon.nhaad.in/dataplane/',
  gatewayApiPath: 'https://aaehackathon.nhaad.in/dataplane/rsp/',

  /** Zoho (or other) contact form POST action URL. Submit goes here via form POST. */
  contactFormActionUrl: '' as string,
  /** API Explorer server base URL (overrides server from OpenAPI YAML). */
  apiExplorerServerUrl: 'https://nha.iudx.io',

  // important links (use paths for footer routerLink; full URLs would duplicate domain in dev)
  importantLinks: {
    home: '/',
    provider: '/provider/home',
    consumer: '/consumer/home',
    canvas: '/canvas',
  },

  helpDeskUrl: 'https://nha.maharashtra.gov.in/help-desk',

  // API Documentation URLs (for footer links)
  apiDocsBaseUrl: 'https://api.nha.org.in',
  controlPlaneApiDocsUrl: 'https://v2.dev.controlplane.iudx.io/apis',
  fileServerApiDocsUrl: 'https://v2.dev.file-s3.iudx.io/apis',
  resourceServerApiDocsUrl: 'https://v2.dev.rs.iudx.io/apis',
  ogcServerApiDocsUrl: 'https://api.nha.org.in/auth',
  sandboxServerApiDocsUrl: 'https://api.nha.org.in/auth',
};
